/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["li[_ngcontent-%COMP%]{cursor:pointer}textarea[_ngcontent-%COMP%]{resize:vertical}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-rejection-modal/request-rejection-modal.component.css.shim.ngstyle.js.pre-build-optimizer.js